import { memo, useEffect, useState } from 'react';
import './ProgressLoader.css';

const ProgressLoader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => prev + 1);
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className='style-loader'>
      <div className='progress-preloader'>
        <div className='progress-count'>
          <span>0%</span>
          <span>25%</span>
          <span>50%</span>
          <span>75%</span>
          <span>100%</span>
        </div>
        <div className='progress'>
          <div style={{ width: progress + '%' }} className='determinate'></div>
        </div>
      </div>
      <h3 style={{ paddingBottom: '50px' }}>
        Processing your order. It might take up to 30 seconds.
        <br />
        Please wait...
      </h3>
    </div>
  );
};

export default memo(ProgressLoader);
